module.exports = __webpack_public_path__ + "static/world-a32b31560172c7107251c2459ab3ed1e.png";